// AlertsModal.js
import Modal from '../../templates/popups/Modal'
import { StaticTable } from '../../templates/tables/StaticTable'
import alertaGif from '../../img/alerta.gif'
import * as con from '../../GlobalConstants'
import { useFetchCOPAlerts } from '../hooks/COPAlertsHooks'

function COPAlertModal() {

  const { currentAlerts, showSseModal, dismissAlerts } = useFetchCOPAlerts()

  const columnArray = [
    { [con.NAME]: 'Tipo',  [con.TYPE]: con.TEXT,  [con.ID]: 'type' },
    { [con.NAME]: 'Nivel', [con.TYPE]: con.MONEY, [con.ID]: 'level' },
    { [con.NAME]: 'Fecha', [con.TYPE]: con.TEXT,  [con.ID]: 'reachedDate' },
  ]

  const dataDictionary = Object.fromEntries(
    currentAlerts.map(alert => [alert.id, alert])
  )

  return (
    <Modal
      show={showSseModal}
      doAccept={dismissAlerts}
      doCancel={() => {}}
      showCancel={false}
      widthPercentage={40}
    >
      {currentAlerts.length > 0 && (
        <div style={{ lineHeight: '1.4' }}>
          <div style={{ textAlign: 'center' }}>
            <img src={alertaGif} alt="Alerta" style={{ width: '50px', height: '50px', marginBottom: '10px' }} />
          </div>
          <h2 style={{ marginBottom: '10px', textAlign: 'center' }}>
            {currentAlerts.length === 1 ? '¡Alerta Alcanzada!' : '¡Alertas Alcanzadas!'}
          </h2>
          <div style={{ marginTop: '20px' }}>
            <StaticTable
              columnArray={columnArray}
              dataDictionary={dataDictionary}
              onclickFunction={null}
              sortable={false}
              fixedSize={25}
            />
          </div>
        </div>
      )}
    </Modal>
  )
}

export default COPAlertModal